/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetCandidateDetailsResponseDto } from '../models';
// @ts-ignore
import type { GetCandidateStatusResponseDto } from '../models';
// @ts-ignore
import type { GetNextPrevCandidateResponseDto } from '../models';
// @ts-ignore
import type { PickCandidatesRequestDto } from '../models';
// @ts-ignore
import type { ReprocessSelectedCandidatesRequestDto } from '../models';
// @ts-ignore
import type { UpdateCandidateRateRequestDto } from '../models';
// @ts-ignore
import type { UpdateProcessCandidateDetailsRequestDto } from '../models';
/**
 * ProcessesCandidatesRestApi - axios parameter creator
 */
export const ProcessesCandidatesRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a candidate
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProcessCandidate: async (processId: string, candidateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('deleteProcessCandidate', 'processId', processId)
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('deleteProcessCandidate', 'candidateId', candidateId)
            const localVarPath = `/api/v1/processes/{processId}/candidates/{candidateId}`
                .replace(`{${"processId"}}`, encodeURIComponent(String(processId)))
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get candidate status
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateStatus: async (processId: string, candidateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getCandidateStatus', 'processId', processId)
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('getCandidateStatus', 'candidateId', candidateId)
            const localVarPath = `/api/v1/processes/{processId}/candidates/{candidateId}/status`
                .replace(`{${"processId"}}`, encodeURIComponent(String(processId)))
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {GetNextPrevCandidateCandidateDirectionEnum} candidateDirection 
         * @param {number} currentPosition 
         * @param {number} [searchId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextPrevCandidate: async (processId: string, candidateId: string, candidateDirection: GetNextPrevCandidateCandidateDirectionEnum, currentPosition: number, searchId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getNextPrevCandidate', 'processId', processId)
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('getNextPrevCandidate', 'candidateId', candidateId)
            // verify required parameter 'candidateDirection' is not null or undefined
            assertParamExists('getNextPrevCandidate', 'candidateDirection', candidateDirection)
            // verify required parameter 'currentPosition' is not null or undefined
            assertParamExists('getNextPrevCandidate', 'currentPosition', currentPosition)
            const localVarPath = `/api/v1/processes/{processId}/candidates/{candidateId}/next`
                .replace(`{${"processId"}}`, encodeURIComponent(String(processId)))
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (candidateDirection !== undefined) {
                localVarQueryParameter['candidateDirection'] = candidateDirection;
            }

            if (searchId !== undefined) {
                localVarQueryParameter['searchId'] = searchId;
            }

            if (currentPosition !== undefined) {
                localVarQueryParameter['currentPosition'] = currentPosition;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get details of a candidate
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessCandidateDetails: async (processId: string, candidateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcessCandidateDetails', 'processId', processId)
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('getProcessCandidateDetails', 'candidateId', candidateId)
            const localVarPath = `/api/v1/processes/{processId}/candidates/{candidateId}`
                .replace(`{${"processId"}}`, encodeURIComponent(String(processId)))
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get CV of a candidate
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessCandidatesCv: async (processId: string, candidateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcessCandidatesCv', 'processId', processId)
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('getProcessCandidatesCv', 'candidateId', candidateId)
            const localVarPath = `/api/v1/processes/{processId}/candidates/{candidateId}/cv`
                .replace(`{${"processId"}}`, encodeURIComponent(String(processId)))
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/pdf';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pick a candidate
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickCandidate: async (processId: string, candidateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('pickCandidate', 'processId', processId)
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('pickCandidate', 'candidateId', candidateId)
            const localVarPath = `/api/v1/processes/{processId}/candidates/{candidateId}/pick`
                .replace(`{${"processId"}}`, encodeURIComponent(String(processId)))
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pick candidates
         * @param {string} processId 
         * @param {PickCandidatesRequestDto} pickCandidatesRequestDto Candidates details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickCandidates: async (processId: string, pickCandidatesRequestDto: PickCandidatesRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('pickCandidates', 'processId', processId)
            // verify required parameter 'pickCandidatesRequestDto' is not null or undefined
            assertParamExists('pickCandidates', 'pickCandidatesRequestDto', pickCandidatesRequestDto)
            const localVarPath = `/api/v1/processes/{processId}/candidates/pick`
                .replace(`{${"processId"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pickCandidatesRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reprocess a candidate
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reprocessCandidate: async (processId: string, candidateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('reprocessCandidate', 'processId', processId)
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('reprocessCandidate', 'candidateId', candidateId)
            const localVarPath = `/api/v1/processes/{processId}/candidates/{candidateId}/reprocess`
                .replace(`{${"processId"}}`, encodeURIComponent(String(processId)))
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reprocess selected candidates
         * @param {string} processId 
         * @param {ReprocessSelectedCandidatesRequestDto} reprocessSelectedCandidatesRequestDto Candidates details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reprocessSelectedCandidates: async (processId: string, reprocessSelectedCandidatesRequestDto: ReprocessSelectedCandidatesRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('reprocessSelectedCandidates', 'processId', processId)
            // verify required parameter 'reprocessSelectedCandidatesRequestDto' is not null or undefined
            assertParamExists('reprocessSelectedCandidates', 'reprocessSelectedCandidatesRequestDto', reprocessSelectedCandidatesRequestDto)
            const localVarPath = `/api/v1/processes/{processId}/candidates/reprocess-selected-candidates`
                .replace(`{${"processId"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reprocessSelectedCandidatesRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update candidate rate
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {UpdateCandidateRateRequestDto} updateCandidateRateRequestDto Candidate rate details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCandidateRate: async (processId: string, candidateId: string, updateCandidateRateRequestDto: UpdateCandidateRateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateCandidateRate', 'processId', processId)
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('updateCandidateRate', 'candidateId', candidateId)
            // verify required parameter 'updateCandidateRateRequestDto' is not null or undefined
            assertParamExists('updateCandidateRate', 'updateCandidateRateRequestDto', updateCandidateRateRequestDto)
            const localVarPath = `/api/v1/processes/{processId}/candidates/{candidateId}/rate`
                .replace(`{${"processId"}}`, encodeURIComponent(String(processId)))
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCandidateRateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update details of a candidate
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {UpdateProcessCandidateDetailsRequestDto} updateProcessCandidateDetailsRequestDto Update candidate details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessCandidateDetails: async (processId: string, candidateId: string, updateProcessCandidateDetailsRequestDto: UpdateProcessCandidateDetailsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessCandidateDetails', 'processId', processId)
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('updateProcessCandidateDetails', 'candidateId', candidateId)
            // verify required parameter 'updateProcessCandidateDetailsRequestDto' is not null or undefined
            assertParamExists('updateProcessCandidateDetails', 'updateProcessCandidateDetailsRequestDto', updateProcessCandidateDetailsRequestDto)
            const localVarPath = `/api/v1/processes/{processId}/candidates/{candidateId}`
                .replace(`{${"processId"}}`, encodeURIComponent(String(processId)))
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProcessCandidateDetailsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessesCandidatesRestApi - functional programming interface
 */
export const ProcessesCandidatesRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcessesCandidatesRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a candidate
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProcessCandidate(processId: string, candidateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProcessCandidate(processId, candidateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCandidatesRestApi.deleteProcessCandidate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get candidate status
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidateStatus(processId: string, candidateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCandidateStatusResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidateStatus(processId, candidateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCandidatesRestApi.getCandidateStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {GetNextPrevCandidateCandidateDirectionEnum} candidateDirection 
         * @param {number} currentPosition 
         * @param {number} [searchId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNextPrevCandidate(processId: string, candidateId: string, candidateDirection: GetNextPrevCandidateCandidateDirectionEnum, currentPosition: number, searchId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNextPrevCandidateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNextPrevCandidate(processId, candidateId, candidateDirection, currentPosition, searchId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCandidatesRestApi.getNextPrevCandidate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get details of a candidate
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessCandidateDetails(processId: string, candidateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCandidateDetailsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessCandidateDetails(processId, candidateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCandidatesRestApi.getProcessCandidateDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get CV of a candidate
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessCandidatesCv(processId: string, candidateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessCandidatesCv(processId, candidateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCandidatesRestApi.getProcessCandidatesCv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Pick a candidate
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pickCandidate(processId: string, candidateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pickCandidate(processId, candidateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCandidatesRestApi.pickCandidate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Pick candidates
         * @param {string} processId 
         * @param {PickCandidatesRequestDto} pickCandidatesRequestDto Candidates details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pickCandidates(processId: string, pickCandidatesRequestDto: PickCandidatesRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pickCandidates(processId, pickCandidatesRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCandidatesRestApi.pickCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reprocess a candidate
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reprocessCandidate(processId: string, candidateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reprocessCandidate(processId, candidateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCandidatesRestApi.reprocessCandidate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reprocess selected candidates
         * @param {string} processId 
         * @param {ReprocessSelectedCandidatesRequestDto} reprocessSelectedCandidatesRequestDto Candidates details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reprocessSelectedCandidates(processId: string, reprocessSelectedCandidatesRequestDto: ReprocessSelectedCandidatesRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reprocessSelectedCandidates(processId, reprocessSelectedCandidatesRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCandidatesRestApi.reprocessSelectedCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update candidate rate
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {UpdateCandidateRateRequestDto} updateCandidateRateRequestDto Candidate rate details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCandidateRate(processId: string, candidateId: string, updateCandidateRateRequestDto: UpdateCandidateRateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCandidateRate(processId, candidateId, updateCandidateRateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCandidatesRestApi.updateCandidateRate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update details of a candidate
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {UpdateProcessCandidateDetailsRequestDto} updateProcessCandidateDetailsRequestDto Update candidate details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessCandidateDetails(processId: string, candidateId: string, updateProcessCandidateDetailsRequestDto: UpdateProcessCandidateDetailsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessCandidateDetails(processId, candidateId, updateProcessCandidateDetailsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCandidatesRestApi.updateProcessCandidateDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProcessesCandidatesRestApi - factory interface
 */
export const ProcessesCandidatesRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcessesCandidatesRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a candidate
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProcessCandidate(processId: string, candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteProcessCandidate(processId, candidateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get candidate status
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateStatus(processId: string, candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetCandidateStatusResponseDto> {
            return localVarFp.getCandidateStatus(processId, candidateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {GetNextPrevCandidateCandidateDirectionEnum} candidateDirection 
         * @param {number} currentPosition 
         * @param {number} [searchId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextPrevCandidate(processId: string, candidateId: string, candidateDirection: GetNextPrevCandidateCandidateDirectionEnum, currentPosition: number, searchId?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetNextPrevCandidateResponseDto> {
            return localVarFp.getNextPrevCandidate(processId, candidateId, candidateDirection, currentPosition, searchId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get details of a candidate
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessCandidateDetails(processId: string, candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetCandidateDetailsResponseDto> {
            return localVarFp.getProcessCandidateDetails(processId, candidateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get CV of a candidate
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessCandidatesCv(processId: string, candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getProcessCandidatesCv(processId, candidateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Pick a candidate
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickCandidate(processId: string, candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.pickCandidate(processId, candidateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Pick candidates
         * @param {string} processId 
         * @param {PickCandidatesRequestDto} pickCandidatesRequestDto Candidates details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickCandidates(processId: string, pickCandidatesRequestDto: PickCandidatesRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.pickCandidates(processId, pickCandidatesRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reprocess a candidate
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reprocessCandidate(processId: string, candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reprocessCandidate(processId, candidateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reprocess selected candidates
         * @param {string} processId 
         * @param {ReprocessSelectedCandidatesRequestDto} reprocessSelectedCandidatesRequestDto Candidates details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reprocessSelectedCandidates(processId: string, reprocessSelectedCandidatesRequestDto: ReprocessSelectedCandidatesRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reprocessSelectedCandidates(processId, reprocessSelectedCandidatesRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update candidate rate
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {UpdateCandidateRateRequestDto} updateCandidateRateRequestDto Candidate rate details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCandidateRate(processId: string, candidateId: string, updateCandidateRateRequestDto: UpdateCandidateRateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCandidateRate(processId, candidateId, updateCandidateRateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update details of a candidate
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {UpdateProcessCandidateDetailsRequestDto} updateProcessCandidateDetailsRequestDto Update candidate details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessCandidateDetails(processId: string, candidateId: string, updateProcessCandidateDetailsRequestDto: UpdateProcessCandidateDetailsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessCandidateDetails(processId, candidateId, updateProcessCandidateDetailsRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessesCandidatesRestApi - interface
 */
export interface ProcessesCandidatesRestApiInterface {
    /**
     * 
     * @summary Delete a candidate
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProcessCandidate(processId: string, candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get candidate status
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCandidateStatus(processId: string, candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetCandidateStatusResponseDto>;

    /**
     * 
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {GetNextPrevCandidateCandidateDirectionEnum} candidateDirection 
     * @param {number} currentPosition 
     * @param {number} [searchId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNextPrevCandidate(processId: string, candidateId: string, candidateDirection: GetNextPrevCandidateCandidateDirectionEnum, currentPosition: number, searchId?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetNextPrevCandidateResponseDto>;

    /**
     * 
     * @summary Get details of a candidate
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessCandidateDetails(processId: string, candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetCandidateDetailsResponseDto>;

    /**
     * 
     * @summary Get CV of a candidate
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessCandidatesCv(processId: string, candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Pick a candidate
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pickCandidate(processId: string, candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Pick candidates
     * @param {string} processId 
     * @param {PickCandidatesRequestDto} pickCandidatesRequestDto Candidates details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pickCandidates(processId: string, pickCandidatesRequestDto: PickCandidatesRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Reprocess a candidate
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reprocessCandidate(processId: string, candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Reprocess selected candidates
     * @param {string} processId 
     * @param {ReprocessSelectedCandidatesRequestDto} reprocessSelectedCandidatesRequestDto Candidates details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reprocessSelectedCandidates(processId: string, reprocessSelectedCandidatesRequestDto: ReprocessSelectedCandidatesRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update candidate rate
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {UpdateCandidateRateRequestDto} updateCandidateRateRequestDto Candidate rate details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCandidateRate(processId: string, candidateId: string, updateCandidateRateRequestDto: UpdateCandidateRateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update details of a candidate
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {UpdateProcessCandidateDetailsRequestDto} updateProcessCandidateDetailsRequestDto Update candidate details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessCandidateDetails(processId: string, candidateId: string, updateProcessCandidateDetailsRequestDto: UpdateProcessCandidateDetailsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ProcessesCandidatesRestApi - object-oriented interface
 */
export class ProcessesCandidatesRestApi extends BaseAPI implements ProcessesCandidatesRestApiInterface {
    /**
     * 
     * @summary Delete a candidate
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteProcessCandidate(processId: string, candidateId: string, options?: RawAxiosRequestConfig) {
        return ProcessesCandidatesRestApiFp(this.configuration).deleteProcessCandidate(processId, candidateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get candidate status
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCandidateStatus(processId: string, candidateId: string, options?: RawAxiosRequestConfig) {
        return ProcessesCandidatesRestApiFp(this.configuration).getCandidateStatus(processId, candidateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {GetNextPrevCandidateCandidateDirectionEnum} candidateDirection 
     * @param {number} currentPosition 
     * @param {number} [searchId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNextPrevCandidate(processId: string, candidateId: string, candidateDirection: GetNextPrevCandidateCandidateDirectionEnum, currentPosition: number, searchId?: number, options?: RawAxiosRequestConfig) {
        return ProcessesCandidatesRestApiFp(this.configuration).getNextPrevCandidate(processId, candidateId, candidateDirection, currentPosition, searchId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get details of a candidate
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessCandidateDetails(processId: string, candidateId: string, options?: RawAxiosRequestConfig) {
        return ProcessesCandidatesRestApiFp(this.configuration).getProcessCandidateDetails(processId, candidateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get CV of a candidate
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessCandidatesCv(processId: string, candidateId: string, options?: RawAxiosRequestConfig) {
        return ProcessesCandidatesRestApiFp(this.configuration).getProcessCandidatesCv(processId, candidateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Pick a candidate
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pickCandidate(processId: string, candidateId: string, options?: RawAxiosRequestConfig) {
        return ProcessesCandidatesRestApiFp(this.configuration).pickCandidate(processId, candidateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Pick candidates
     * @param {string} processId 
     * @param {PickCandidatesRequestDto} pickCandidatesRequestDto Candidates details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pickCandidates(processId: string, pickCandidatesRequestDto: PickCandidatesRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCandidatesRestApiFp(this.configuration).pickCandidates(processId, pickCandidatesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reprocess a candidate
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reprocessCandidate(processId: string, candidateId: string, options?: RawAxiosRequestConfig) {
        return ProcessesCandidatesRestApiFp(this.configuration).reprocessCandidate(processId, candidateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reprocess selected candidates
     * @param {string} processId 
     * @param {ReprocessSelectedCandidatesRequestDto} reprocessSelectedCandidatesRequestDto Candidates details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reprocessSelectedCandidates(processId: string, reprocessSelectedCandidatesRequestDto: ReprocessSelectedCandidatesRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCandidatesRestApiFp(this.configuration).reprocessSelectedCandidates(processId, reprocessSelectedCandidatesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update candidate rate
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {UpdateCandidateRateRequestDto} updateCandidateRateRequestDto Candidate rate details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCandidateRate(processId: string, candidateId: string, updateCandidateRateRequestDto: UpdateCandidateRateRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCandidatesRestApiFp(this.configuration).updateCandidateRate(processId, candidateId, updateCandidateRateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update details of a candidate
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {UpdateProcessCandidateDetailsRequestDto} updateProcessCandidateDetailsRequestDto Update candidate details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessCandidateDetails(processId: string, candidateId: string, updateProcessCandidateDetailsRequestDto: UpdateProcessCandidateDetailsRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCandidatesRestApiFp(this.configuration).updateProcessCandidateDetails(processId, candidateId, updateProcessCandidateDetailsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

export const GetNextPrevCandidateCandidateDirectionEnum = {
    Next: 'NEXT',
    Prev: 'PREV'
} as const;
export type GetNextPrevCandidateCandidateDirectionEnum = typeof GetNextPrevCandidateCandidateDirectionEnum[keyof typeof GetNextPrevCandidateCandidateDirectionEnum];
